import { ReactElement } from 'react';
import { BoundedContent, Column, GridContainer, Icon, P, Row } from '@vp/swan';
import { __ } from '@99designs/i18n';

type ValuePropositionItem = {
    title: string;
    icon: ReactElement;
};

export function VistaValueProposition() {
    const VALUE_PROPOSITION: ValuePropositionItem[] = [
        {
            title: __('Global community of vetted, professional designers'),
            icon: <Icon iconType="magic" />,
        },
        {
            title: __('Wide range of design services available to help grow your brand'),
            icon: <Icon iconType="heart" />,
        },
        {
            title: __('24/7 Customer Care agents to support your design and print journey'),
            icon: <Icon iconType="liveChat" />,
        },
        {
            title: __('Print your design on (almost) anything, merch, packaging and more'),
            icon: <Icon iconType="delivery" />,
        },
    ];

    return (
        <BoundedContent>
            <GridContainer as="ul">
                <Row as="li">
                    {VALUE_PROPOSITION.map((item, index) => (
                        <Column span={3} key={index} textAlign="center">
                            {item.icon}
                            <P marginBottom={{ xs: 8, sm: 5 }}>{item.title}</P>
                        </Column>
                    ))}
                </Row>
            </GridContainer>
        </BoundedContent>
    );
}
